module.exports = "<input \n  type=\"tel\" \n  class=\"form-control{{$ctrl.class ? ' ' + $ctrl.class : ''}}\"\n  ng-model=\"$ctrl.ngModel\"\n  placeholder=\"{{$ctrl.placeholder || '(XXX) XXX-XXXX'}}\"\n  ng-disabled=\"$ctrl.disabled\"\n  ng-required=\"$ctrl.required\"\n  ng-change=\"$ctrl.onInputChange()\"\n  ng-blur=\"$ctrl.formatPhoneNumber()\"\n  maxlength=\"14\">\n</input>\n\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/phone-number/tc-phone-number.html
// module id = 552
// module chunks = 0